/**
 * @generated SignedSource<<884a1e14cfdd44a73830ea4f62f6d0a3>>
 * @relayHash bd6ddc6490be144ce6f8bbfe580a337c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd6ddc6490be144ce6f8bbfe580a337c

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteGeneralAttestationInput = {
  id: string;
};
export type useDeDeleteGeneralAttestationMutation$variables = {
  input: De_deleteGeneralAttestationInput;
};
export type useDeDeleteGeneralAttestationMutation$data = {
  readonly de_deleteGeneralAttestation: {
    readonly de_GeneralAttestation: {
      readonly id: string;
    } | null;
  };
};
export type useDeDeleteGeneralAttestationMutation = {
  response: useDeDeleteGeneralAttestationMutation$data;
  variables: useDeDeleteGeneralAttestationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeDeleteGeneralAttestationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_deleteGeneralAttestationPayload",
        "kind": "LinkedField",
        "name": "de_deleteGeneralAttestation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_GeneralAttestation",
            "kind": "LinkedField",
            "name": "de_GeneralAttestation",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeDeleteGeneralAttestationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_deleteGeneralAttestationPayload",
        "kind": "LinkedField",
        "name": "de_deleteGeneralAttestation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_GeneralAttestation",
            "kind": "LinkedField",
            "name": "de_GeneralAttestation",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "bd6ddc6490be144ce6f8bbfe580a337c",
    "metadata": {},
    "name": "useDeDeleteGeneralAttestationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a12211f2abf8ee8a3ea7d0a1455067ad";

export default node;
